import { Create, ListButton, TopToolbar } from 'react-admin'
import { AppointmentForm, appointmentRelations } from '~/components'

const AppointmentCreateActions = ({ data }) => (
  <TopToolbar>
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

const AppointmentCreate = (props) => {
  return (
    <Create
      title='resources.appointments.create'
      actions={<AppointmentCreateActions />}
      {...props}
      transform={appointmentRelations}
      redirect='list'
    >
      <AppointmentForm />
    </Create>
  )
}

export default AppointmentCreate
